module.exports = __webpack_public_path__ + "static/WhatsApp_icon-d266b6114ffcaf2dfb0b7cca64d4968b.png";